import { playerStoreKeys } from '../playerStoreConstants'
import { useSetPlayerStoreData } from '../hooks'

export const useSetLastGameLoaded = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()

  const setLastGameLoaded = game => {
    if (game !== null) {
      setPlayerStoreData({ [playerStoreKeys.lastGameLoaded]: game }, 'setLastGameLoaded ')
    }
  }
  return { setLastGameLoaded }
}
